import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    PageWrapper,
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { Achievements } from '../../components/achievements'
import { FilterBtn } from '../../styles/results'
import {
    MdFilterList
} from "react-icons/md";
import { ResultsList } from '../../components/results-list'

const Results = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <PageWrapper>
                            <FilterBtn>
                                <div className="icon-container">
                                    <MdFilterList />
                                </div>
                                filters
                            </FilterBtn>
                            <Heading>
                                Results
                            </Heading>
                            <Breadcrumb
                                crumbs={['Results']}
                            />
                            <ResultsList />
                            <Achievements type='results' />
                        </PageWrapper>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Results
